<script setup lang="tsx">
const props = defineProps(["preventClose", "ui"]);
const emit = defineEmits(["after-leave"]);
const isOpen = defineModel<boolean>();
const slots = useSlots();
</script>

<template>
  <UModal
    v-model="isOpen"
    :prevent-close="props.preventClose"
    :ui="props.ui"
    @after-leave="emit('after-leave')"
  >
    <UCard
      :ui="{
        shadow: '',
        ring: '',
        divide: 'divide-opacity-0 dark:divide-opacity-0 divide-transparent',
        header: {
          padding: 'pb-2',
        },
        body: {
          padding: 'px-4 sm:px-6 py-3 sm:py-3 ' + (slots.footer == null ? 'pb-5' : ''),
          base: 'overflow-y-auto max-h-[80dvh]',
        },
        footer: {
          padding: 'pt-2',
        },
      }"
    >
      <template #header>
        <slot name="header" />
      </template>

      <div class="">
        <slot />
      </div>

      <template v-if="slots.footer" #footer>
        <slot name="footer" />
      </template>
    </UCard>
  </UModal>
</template>
